import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import { createPinia } from 'pinia'
import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'
import 'leaflet/dist/leaflet.css'
import { useUserStore } from './stores/user-store'
import { listenForInstallPrompt } from './composables/usePwaInstall'
import globalDarkHref from './stores/global-dark.css?url'
import globalLightHref from './stores/global-colors.css?url'
// Tokens de cor das telas de painel (Monitoring/Indicadores). Carregado sempre,
// não pelo <link id="app-theme">, que troca entre os dois globais.
import './styles/panel-theme.css'

  ; (function initThemeLink() {
    function ensureLink() {
      var el = document.getElementById('app-theme') as HTMLLinkElement | null
      if (!el) {
        el = document.createElement('link')
        el.setAttribute('id', 'app-theme')
        el.setAttribute('rel', 'stylesheet')
        document.head.appendChild(el)
      }
      return el as HTMLLinkElement
    }
    function hrefFor(theme: string) {
      return theme === 'dark' ? globalDarkHref : globalLightHref
    }

    ensureLink()

      ; (window as any).setAppTheme = function (next: string) {
        var val = next === 'dark' ? 'dark' : 'light'
        var lk = ensureLink()
        lk.href = hrefFor(val)
        var r = document.documentElement
        if (r) {
          r.classList.remove('theme-dark', 'theme-light')
          r.classList.add(val === 'dark' ? 'theme-dark' : 'theme-light')
        }
        try { window.dispatchEvent(new Event('app-theme-changed')) } catch (e) { }
      }

      ; (window as any).getAppTheme = function () {
        var cls = document.documentElement && document.documentElement.className || ''
        if (cls.indexOf('theme-dark') !== -1) return 'dark'
        if (cls.indexOf('theme-light') !== -1) return 'light'
        return null
      }
  })()

import L from 'leaflet'
delete (L.Icon.Default.prototype as any)._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).toString(),
  iconUrl: new URL('leaflet/dist/images/marker-icon.png', import.meta.url).toString(),
  shadowUrl: new URL('leaflet/dist/images/marker-shadow.png', import.meta.url).toString(),
})

// Antes do mount: o beforeinstallprompt pode chegar enquanto o boot espera o /users/me.
listenForInstallPrompt()

const app = createApp(App)
const pinia = createPinia()

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.use(pinia)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

; (async function boot() {
  var token = null
  try { token = localStorage.getItem('authToken') } catch (e) { }

  if (token) {
    try {
      const userStore = useUserStore(pinia)
      await userStore.fetchUserData()
      var isDark = String(userStore.theme || '').toLowerCase() === 'dark'
      if (typeof window !== 'undefined' && (window as any).setAppTheme) {
        ; (window as any).setAppTheme(isDark ? 'dark' : 'light')
      }
    } catch (e) { }
  }

  app.mount('#app')
})()
